<template>
  <div class="customer">
    <div class="containt" ref="imageWrapper">
      <div class="main">
        <div class="top">
          <ul>
            <li>
              <span class="left">客户姓名</span>
              <span class="right">{{ information.presentee }}</span>
            </li>
            <li>
              <span class="left">联系电话</span>
              <span class="right">{{ information.contactNumber }}</span>
            </li>
            <li>
              <span class="left">项目城市</span>
              <span class="right">{{ information.orgName }}</span>
            </li>
            <li>
              <span class="left">推荐项目</span>
              <span class="right">{{ information.projectName }}</span>
            </li>
          </ul>
          <div class="img">
            <img src="../../common/images/recommend/secrecy.png" alt="" />
          </div>
        </div>

        <div>
          <img src="../../common/images/recommend/line.png" alt="" />
        </div>
        <ul class="recommend">
          <li>
            <span class="left"> 推荐人</span>
            <span class="right">{{ information.recommendName }}</span>
          </li>
          <li>
            <span class="left"> 推荐人电话</span>
            <span class="right">{{ information.recUserMobile }}</span>
          </li>
          <li>
            <span class="left">推荐日期</span>
            <span class="right">{{ information.createDate }}</span>
          </li>
        </ul>
      </div>
      <div class="name">
        <ul>
          <li>
            <span class="left"> 分配人</span>
            <span class="right">{{ information.distributeName }}</span>
          </li>
          <li>
            <span class="left">分配时间</span>
            <span class="right">{{ information.distributeDate }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="foot">
      <span @click="distribution">立即分配</span>
      <!-- 分享面板 -->
      <van-share-sheet
        v-model="showShare"
        :options="options"
        @select="onSelect"
      />
    </div>
    <div v-if="this.imgUrl" class="poster">
      <van-dialog
        v-model="show"
        title="长按图片保存到本地"
        show-cancel-button
        @confirm="handleConfirm"
      >
        <img :src="this.imgUrl" alt="" />
      </van-dialog>
    </div>
  </div>
</template>

<script>
import * as api from "../../api";
import { ShareSheet, Dialog, Notify, Toast } from "vant";
import html2canvas from "html2canvas";

import ossUpload from "@src/_common/mixins/ossUpload";
export default {
  mixins: [ossUpload],
  name: "Customer",
  data() {
    return {
      show: false,
      imgUrl: "", // 最终生成的海报图片
      information: "",
      showShare: false,
      ossConfig: "",
      options: [
        {
          name: "微信",
          icon: require("../../common/images/recommend/wx_icon.png"),
        },
      ],
    };
  },
  components: {
    "van-share-sheet": ShareSheet,
    [Notify.name]: Notify,
    [Dialog.Component.name]: Dialog.Component,
    // uploadImg,
  },
  created() {
    this.$store.dispatch("getOssToken");

    api.getDetailsById({ id: this.$route.query }).then((res) => {
      this.information = res.body;
    });
  },
  methods: {
    //确认保存
    handleConfirm() {
      this.$router.push({
        name: "OldNew",
      });
    },
    //立即分配
    distribution() {
      api
        .distribute(this.$route.query)
        .then(() => {
          this.showShare = true;
        })
        .catch(() => {
          Toast.fail("分配失败");
        });
    },
    // 保存
    saveFile(data, filename) {
      const save_link = document.createElementNS(
        "http://www.w3.org/1999/xhtml",
        "a"
      );
      save_link.href = data;
      save_link.download = filename;

      const event = document.createEvent("MouseEvents");
      event.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      save_link.dispatchEvent(event);
    },

    //分享或下载
    onSelect(option) {
      if (option.name === "微信") {
        html2canvas(this.$refs.imageWrapper).then((canvas) => {
          let dataURL = canvas.toDataURL("image/png");
          this.imgUrl = dataURL;

          let base64 = dataURL.split(",")[1];

          this.base64ToBlob({ b64data: base64, contentType: "image/png" }).then(
            (res) => {
              // 转后后的blob对象

              this.ossUpload(res).then((res) => {
                this.$mUtils.commonCall("shareImage", "1", res.url); //1为微信，0位朋友圈

                this.$router.push({
                  name: "OldNew",
                });
              });
            }
          );
        });
      } else {
        html2canvas(this.$refs.imageWrapper).then((canvas) => {
          let dataURL = canvas.toDataURL("image/png");
          this.imgUrl = dataURL;

          let base64 = dataURL.split(",")[1];

          this.base64ToBlob({ b64data: base64, contentType: "image/png" }).then(
            () => {
              // 转后后的blob对象
            }
          );

          this.$jsBridge.callHandler("saveFile", this.imgUrl, (res) => {
            if (res === 0) {
              Notify({ type: "success", message: "下载成功" });
            } else {
              Notify({ type: "danger", message: "下载失败" });
            }
          });
        });

        this.show = true;
      }
      this.showShare = false;
    },
    //图片下载事件
    imageDown() {
      this.$jsBridge.callHandler("saveFile", this.imgUrl, (res) => {
        if (res === 0) {
          Notify({ type: "success", message: "下载成功" });
        } else {
          Notify({ type: "danger", message: "下载失败" });
        }
      });
    },
    // 原理：利用URL.createObjectURL为blob对象创建临时的URL

    base64ToBlob({ b64data = "", contentType = "", sliceSize = 512 } = {}) {
      return new Promise((resolve) => {
        // 使用 atob() 方法将数据解码
        let byteCharacters = atob(b64data);
        let byteArrays = [];
        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          let slice = byteCharacters.slice(offset, offset + sliceSize);
          let byteNumbers = [];
          for (let i = 0; i < slice.length; i++) {
            byteNumbers.push(slice.charCodeAt(i));
          }
          // 8 位无符号整数值的类型化数组。内容将初始化为 0。
          // 如果无法分配请求数目的字节，则将引发异常。
          byteArrays.push(new Uint8Array(byteNumbers));
        }
        let result = new Blob(byteArrays, {
          type: contentType,
        });
        result = Object.assign(result, {
          // jartto: 这里一定要处理一下 URL.createObjectURL
          preview: URL.createObjectURL(result),
          name: `图片示例.png`,
        });
        resolve(result);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customer {
  padding: 20px;
  .test {
    height: 100%;
    width: 100%;
  }
  .containt {
    height: 90%;
    width: 100%;
    background: url("../../common/images/recommend/old_bg.png") center center;
    background-size: 100% 100%;
    padding: 272px 40px 0;
    li {
      line-height: 40px;
      margin-bottom: 30px;
      .left {
        font-family: PingFangSC-Regular, PingFang SC;
        width: 140px;
        display: inline-block;
        color: rgba(102, 102, 102, 1);
        margin-right: 62px;
      }
      .right {
        font-family: PingFangSC-Regular, PingFang SC;

        color: rgba(51, 51, 51, 1);
      }
    }
    .main {
      width: 630px;
      height: 596px;
      background-color: #fff;
      border-radius: 8px;
      padding: 0 16px 0 36px;

      .top {
        display: flex;
        justify-content: space-between;
        width: 100%;
        ul {
          width: 440px;
          padding: 50px 0px 0 0px;
        }
        .img {
          padding: 16px 0px;
          height: 50%;
          img {
            width: 164px;
            height: 142px;
          }
        }
      }
      .recommend {
        margin-top: 20px;
      }
    }
    .name {
      padding: 36px;
      width: 630px;
      height: 190px;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      margin-top: 30px;
    }
  }
  .foot {
    margin-top: 50px;
    width: 100%;
    text-align: center;
    span {
      display: inline-block;
      width: 320px;
      height: 76px;
      background: rgba(13, 152, 105, 1);
      border-radius: 40px;
      line-height: 76px;
      color: #fff;
      font-size: 32px;
    }
  }
  /deep/ .van-share-sheet__options {
    background: rgba(247, 248, 248, 1);
    box-shadow: 0px -2px 10px 0px rgba(153, 153, 153, 0.5);
    border-radius: 10px 10px 0px 0px;
    opacity: 0.98;
    padding-bottom: 50px !important;
    display: flex;
    justify-content: space-around;
    .van-share-sheet__option {
      width: 112px;
      height: 112px;
      background: rgba(255, 255, 255, 1);
      border-radius: 14px;
      // padding-top: 30px;
      img {
        width: 62px;
        height: 52px;
        margin-top: 30px;
        margin-bottom: 30px;
      }
      /deep/.van-share-sheet__name {
        font-size: 20px;
      }
    }
    .van-share-sheet__option:nth-child(2) {
      img {
        width: 48px;
        height: 46px;
      }
    }
  }
  .poster {
    .van-dialog {
      margin-top: 40px;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
